"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AuthApplication;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _webApiClient = _interopRequireDefault(require("@jusda-tools/web-api-client"));
var _envConfig = _interopRequireDefault(require("./envConfig.js"));
var _jusdaUserInfo = _interopRequireDefault(require("./jusdaUserInfo.js"));
var _jusdaPublicmethod = require("@jusda-tools/jusda-publicmethod");
var _window$jusdaBaseConf = window.jusdaBaseConfig,
  isMobile = _window$jusdaBaseConf.isMobile,
  isIntranet = _window$jusdaBaseConf.isIntranet;
var url403 = _envConfig["default"].url403,
  mobileUrl403 = _envConfig["default"].mobileUrl403,
  applicationAuthUrl = _envConfig["default"].applicationAuthUrl;
var languageMsg = new Map().set('zh-CN', '当前账号没有访问权限，请重新登陆!').set('en-US', 'The current account does not have access rights, please log in again');
function AuthApplication() {
  return _AuthApplication.apply(this, arguments);
}
function _AuthApplication() {
  _AuthApplication = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, data, success;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _webApiClient["default"].get(applicationAuthUrl);
        case 2:
          response = _context.sent;
          if (response) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", check403type());
        case 5:
          data = response.data, success = response.success;
          if (!(data && success)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", Promise.resolve());
        case 10:
          return _context.abrupt("return", check403type());
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _AuthApplication.apply(this, arguments);
}
function currentLanguage() {
  var LANGS = ['en-US', 'zh-CN'];
  var cookieLang = new _jusdaPublicmethod.CookieTools().get(_jusdaPublicmethod.JUSDA_LANGUAGE);
  if (LANGS.includes(cookieLang)) {
    return cookieLang;
  }
  var isNavigatorLanguageValid = typeof navigator !== 'undefined' && typeof navigator.language === 'string';
  if (isNavigatorLanguageValid) {
    var _navigator$language$s = navigator.language.split('-'),
      _navigator$language$s2 = (0, _slicedToArray2["default"])(_navigator$language$s, 1),
      browserLangPrefix = _navigator$language$s2[0];
    return browserLangPrefix === 'zh' ? 'zh-CN' : 'en-US';
  }
}
function check403type() {
  if (isMobile) {
    // new JusdaUserInfo().logout();
    window.location.href = mobileUrl403;
    return Promise.reject();
  }
  // else if (isIntranet === true) {
  //     // 内网环境访问 跳转到登录页面
  //     const language = currentLanguage() === 'zh-CN' ? 'zh-CN' : 'en-US'
  //     alert(languageMsg.get(language));
  //     new JusdaUserInfo().logout();
  //     return Promise.reject();
  // }
  else {
    window.location.href = url403;
    return Promise.reject();
  }
}